import ModWebParts from './containers/ModWebParts';
import React from "react";
// import 'primeicons/primeicons.css';
import 'primeflex/primeflex.min.css';
//main container component
const App =  (props) => {
    return <ModWebParts webPartProperties={props.webPartProperties} />
}
export default App;
 
